import { ContentModelId } from '../../../../../types/ContentModelId'
import type { PartnerId } from '../../../../../types/PartnerId'
import type { UniversePage, UniversePageBlock } from '../../../domain/UniversePage'
import type { UniversePageDTO } from '../../../domain/UniversePageDTO'

import { isNonNullableEntryDTO } from '../../../../../utils/non-nullable-entry-dto'

import { mapEntryDTOList } from '../../../../../utils/map-entry-dto-list'
import { mapUniverseGeneralInformationFromApi } from '../../../../universe-general-information/infrastructure/repository/mapper/universe-general-information.mapper'

export const mapUniversePageFromApi = (dto: UniversePageDTO, partnerId?: PartnerId): UniversePage | undefined => {
  if (!isNonNullableEntryDTO(dto)) {
    return undefined
  }

  const { blocs, haveNavArrow, informations, navigationAnchorEnabled, withBanner } = dto.fields

  const blocks = mapEntryDTOList<UniversePageBlock>(blocs, partnerId) || []

  return {
    blocks,
    contentType: ContentModelId.UNIVERSE_PAGE,
    informations: mapUniverseGeneralInformationFromApi(informations)!,
    hasNavArrow: Boolean(haveNavArrow),
    navigationAnchorEnabled,
    withBanner: Boolean(withBanner),
  }
}
